import { ChecklistTemplate } from './types';
import { DETECCION_INCENDIOS_TEMPLATE } from './deteccionIncendios';
import { DETECCION_CO_TEMPLATE } from './deteccionCO';
import { DETECCION_GASES_TEMPLATE } from './deteccionGases';
import { INTRUSION_TEMPLATE } from './intrusion';
import { CCTV_TEMPLATE } from './cctv';
import { ACCESOS_TEMPLATE } from './accesos';
import { EXTINTORES_TEMPLATE } from './extintores';
import { BIES_HIDRANTES_TEMPLATE } from './biesHidrantes';
import { HIDRANTES_TEMPLATE } from './hidrantes';
import { EXUTORIOS_TEMPLATE } from './exutorios';
import { SOBREPRESION_TEMPLATE } from './sobrepresion';
import { TUBERIA_TEMPLATE } from './tuberia';
import { PUERTAS_CORTAFUEGOS_TEMPLATE } from './puertasCortafuegos';
import { EXTINCION_GASEOSA_TEMPLATE } from './extincionGaseosa';
import { ALUMBRADO_SENALIZACION_TEMPLATE } from './alumbradoSenalizacion';
import { GRUPO_PRESION_TEMPLATE } from './grupoPresion';

/** Plantillas por tipo de sistema. */
const TEMPLATES: Record<string, ChecklistTemplate> = {
  pci_deteccion_incendios: DETECCION_INCENDIOS_TEMPLATE,
  pci_deteccion_co: DETECCION_CO_TEMPLATE,
  pci_deteccion_gases: DETECCION_GASES_TEMPLATE,
  'intrusión': INTRUSION_TEMPLATE,
  CCTV: CCTV_TEMPLATE,
  control_accesos: ACCESOS_TEMPLATE,
  extintores: EXTINTORES_TEMPLATE,
  bies_hidrantes: BIES_HIDRANTES_TEMPLATE,
  hidrantes: HIDRANTES_TEMPLATE,
  pci_exutorios: EXUTORIOS_TEMPLATE,
  pci_sobrepresion: SOBREPRESION_TEMPLATE,
  pci_tuberia: TUBERIA_TEMPLATE,
  pci_puertas_cortafuegos: PUERTAS_CORTAFUEGOS_TEMPLATE,
  pci_extincion_gaseosa: EXTINCION_GASEOSA_TEMPLATE,
  pci_alumbrado_senalizacion: ALUMBRADO_SENALIZACION_TEMPLATE,
  pci_grupo_presion: GRUPO_PRESION_TEMPLATE,
};





export const getChecklistTemplate = (tipoSistema: string): ChecklistTemplate | null => {
  return TEMPLATES[tipoSistema] ?? null;
};

export const hasChecklistTemplate = (tipoSistema: string): boolean => {
  return tipoSistema in TEMPLATES;
};
